'use client';

import { createToggleStore } from '@/lib/utils/createToggleStore';

export const useAcknowledgement = createToggleStore({
  allowNull: true,
  persistStoreKey: 'acknowledgement-store',
  defaultValue: null,
});
